import React from "react";

import "./BackButton.css";

export const BackButton = ({onClick}) => {

    const handleClick = () => {
        onClick()
    }

    return (
        <div className="back-button-container" onClick={handleClick}>
            <div className="back-button-arrow"/>
            <button className="back-button">Back</button>
        </div>
    );
}
